import React, { FC, ReactNode } from 'react'
import { Row, RowProps } from 'antd'

type TLayoutFormSimpleProps = {
  footer?: ReactNode
  rowProps?: RowProps
}

const LayoutFormSimple: FC<TLayoutFormSimpleProps> = ({
  children,
  footer,
  rowProps,
}) => {
  return (
    <Row {...rowProps}>
      {children}
      {footer}
    </Row>
  )
}

export default LayoutFormSimple
